import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.defaults.headers.post["Content-Type"] = "application/json";

const authUser = localStorage.getItem("authPOSUser");
const storedataid = localStorage.getItem("storedataid");
const token = authUser ? JSON.parse(authUser)?.token : null;


const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    if (!exp) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime > exp;
  } catch (err) {
    return true;
  }
};

// Check token and redirect if expired
const checkTokenAndRedirect = () => {
  if (token && isTokenExpired(token)) {
    localStorage.removeItem("authPOSUser");
    window.location.href = "/login";
    return true;
  }
  return false;
};

if (token && !isTokenExpired(token)) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
} else if (token) {
  checkTokenAndRedirect();
}

if (storedataid) {
  axios.defaults.headers.common["StoreId"] = storedataid;
}

// Global response interceptor
axios.interceptors.response.use(
  response => response.data || response,
  error => {
    const status = error.response?.status;
    if (status === 401) {
      setTimeout(() => {
        alert("Your session has expired");
        return window.location.href = "/login";
      }, 2000)
    }
    const message =
      status === 500 ? "Internal Server Error" :
        status === 401 ? "Invalid credentials" :
          status === 404 ? "Not Found" :
            error.message || "Something went wrong";

    return Promise.reject(message);
  }
);

const setAuthorization = (token: string) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

class APIClient {
  get = (url: string, params?: object) => axios.get(url, { params });

  post = (url: string, data: object) => {
    const isFormData = data instanceof FormData;
    return axios.post(url, data, {
      headers: {
        "Content-Type": isFormData ? undefined : "application/json",
      },
    });
  };

  put = (url: string, data: object) => {
    const isFormData = data instanceof FormData;
    return axios.put(url, data, {
      headers: {
        "Content-Type": isFormData ? undefined : "application/json",
      },
    });
  };

  patch = (url: string, data: object) => {
    const isFormData = data instanceof FormData;
    return axios.patch(url, data, {
      headers: {
        "Content-Type": isFormData ? undefined : "application/json",
      },
    });
  };

  delete = (url: string) => axios.delete(url);
}


const getLoggedinUser = () => {

  const user = localStorage.getItem("authPOSUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export const apiClient = new APIClient();
export { setAuthorization, getLoggedinUser };
